import { useQuery } from '@tanstack/react-query'
import { useAuth } from 'src/contexts/auth'
import { PregnancyDiagnosisController } from 'src/controllers/pregnancy-diagnosis.controller'
import { PregnancyDiagnosisDto } from 'src/dto/pregnancy-diagnosis.dto'

const pregnancyDiagnosisController = new PregnancyDiagnosisController()

export function useGetPregnancyDiagnosisList() {
  const { userFarm: farmId } = useAuth()

  return useQuery<PregnancyDiagnosisDto[], Error>({
    queryKey: ['getPregnancyDiagnosis', farmId],
    queryFn: () => pregnancyDiagnosisController.getPregnancyDiagnosisListByFarmId(farmId!),
    enabled: !!farmId
  })
}
